import type { SubscriptionBoxHistories } from '@lib/types/subscription-box'

import Modal from '@components/Modal'
import PastBoxesReviewSlider from '@components/subscription-box/PastBoxReviewSlider'

type Props = {
	order: SubscriptionBoxHistories[number]
	activeOrder: string | null
	closeModal: () => void
}

export default function MonthlyBoxOrderModal({ order, activeOrder, closeModal }: Props) {
	return (
		<Modal
			isOpen={activeOrder === order?.fulfillmentOrderId}
			closeModal={closeModal}
			desktopStyle="full-screen"
		>
			<PastBoxesReviewSlider box={order?.productSelections} />
		</Modal>
	)
}
